import { accessibilityPaths, addNotePaths, addPlaylistPaths, addUserPaths, addPaths, airplayPaths, arrowCollapseInPaths, arrowCollapsePaths, arrowDownPaths, arrowExpandOutPaths, arrowExpandPaths, arrowLeftPaths, arrowRightPaths, arrowUpPaths, bookmarkPaths, cameraPaths, chaptersPaths, chatCollapsePaths, chatPaths, checkPaths, chevronDownPaths, chevronLeftPaths, chevronRightPaths, chevronUpPaths, chromecastPaths, clipPaths, closedCaptionsOnPaths, closedCaptionsPaths, commentPaths, computerPaths, devicePaths, downloadPaths, episodesPaths, eyePaths, fastBackwardPaths, fastForwardPaths, flagPaths, fullscreenArrowExitPaths, fullscreenArrowPaths, fullscreenExitPaths, fullscreenPaths, heartPaths, infoPaths, languagePaths, linkPaths, lockClosedPaths, lockOpenPaths, menuHorizontalPaths, menuVerticalPaths, microphonePaths, mobilePaths, moonPaths, musicOffPaths, musicPaths, mutePaths, nextPaths, noEyePaths, notificationPaths, odometerPaths, pausePaths, pictureInPictureExitPaths, pictureInPicturePaths, playPaths, playbackSpeedCirclePaths, playlistPaths, previousPaths, questionMarkPaths, queueListPaths, radioButtonSelectedPaths, radioButtonPaths, repeatOnPaths, repeatSquareOnPaths, repeatSquarePaths, repeatPaths, replayPaths, rotatePaths, searchPaths, seekBackward10Paths, seekBackward15Paths, seekBackward30Paths, seekBackwardPaths, seekForward10Paths, seekForward15Paths, seekForward30Paths, seekForwardPaths, sendPaths, settingsMenuPaths, settingsSwitchPaths, settingsPaths, shareArrowPaths, sharePaths, shuffleOnPaths, shufflePaths, stopPaths, subtitlesPaths, sunPaths, theatreModeExitPaths, theatreModePaths, thumbsDownPaths, thumbsUpPaths, timerPaths, transcriptPaths, tvPaths, userPaths, volumeHighPaths, volumeLowPaths, xMarkPaths } from 'media-icons';
import { forwardRef, createElement } from 'react';
import { Icon } from './chunks/vidstack-CBF7iUqu.js';

const cn = (className) => className ? `${className} vds-icon` : "vds-icon";
const AccessibilityIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: accessibilityPaths });
});
AccessibilityIcon.displayName = "VidstackAccessibilityIcon";
const AddNoteIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: addNotePaths });
});
AddNoteIcon.displayName = "VidstackAddNoteIcon";
const AddPlaylistIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: addPlaylistPaths });
});
AddPlaylistIcon.displayName = "VidstackAddPlaylistIcon";
const AddUserIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: addUserPaths });
});
AddUserIcon.displayName = "VidstackAddUserIcon";
const AddIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: addPaths });
});
AddIcon.displayName = "VidstackAddIcon";
const AirPlayIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: airplayPaths });
});
AirPlayIcon.displayName = "VidstackAirPlayIcon";
const ArrowCollapseInIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: arrowCollapseInPaths });
});
ArrowCollapseInIcon.displayName = "VidstackArrowCollapseInIcon";
const ArrowCollapseIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: arrowCollapsePaths });
});
ArrowCollapseIcon.displayName = "VidstackArrowCollapseIcon";
const ArrowDownIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: arrowDownPaths });
});
ArrowDownIcon.displayName = "VidstackArrowDownIcon";
const ArrowExpandOutIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: arrowExpandOutPaths });
});
ArrowExpandOutIcon.displayName = "VidstackArrowExpandOutIcon";
const ArrowExpandIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: arrowExpandPaths });
});
ArrowExpandIcon.displayName = "VidstackArrowExpandIcon";
const ArrowLeftIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: arrowLeftPaths });
});
ArrowLeftIcon.displayName = "VidstackArrowLeftIcon";
const ArrowRightIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: arrowRightPaths });
});
ArrowRightIcon.displayName = "VidstackArrowRightIcon";
const ArrowUpIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: arrowUpPaths });
});
ArrowUpIcon.displayName = "VidstackArrowUpIcon";
const BookmarkIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: bookmarkPaths });
});
BookmarkIcon.displayName = "VidstackBookmarkIcon";
const CameraIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: cameraPaths });
});
CameraIcon.displayName = "VidstackCameraIcon";
const ChaptersIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: chaptersPaths });
});
ChaptersIcon.displayName = "VidstackChaptersIcon";
const ChatCollapseIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: chatCollapsePaths });
});
ChatCollapseIcon.displayName = "VidstackChatCollapseIcon";
const ChatIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: chatPaths });
});
ChatIcon.displayName = "VidstackChatIcon";
const CheckIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: checkPaths });
});
CheckIcon.displayName = "VidstackCheckIcon";
const ChevronDownIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: chevronDownPaths });
});
ChevronDownIcon.displayName = "VidstackChevronDownIcon";
const ChevronLeftIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: chevronLeftPaths });
});
ChevronLeftIcon.displayName = "VidstackChevronLeftIcon";
const ChevronRightIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: chevronRightPaths });
});
ChevronRightIcon.displayName = "VidstackChevronRightIcon";
const ChevronUpIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: chevronUpPaths });
});
ChevronUpIcon.displayName = "VidstackChevronUpIcon";
const ChromecastIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: chromecastPaths });
});
ChromecastIcon.displayName = "VidstackChromecastIcon";
const ClipIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: clipPaths });
});
ClipIcon.displayName = "VidstackClipIcon";
const ClosedCaptionsOnIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: closedCaptionsOnPaths });
});
ClosedCaptionsOnIcon.displayName = "VidstackClosedCaptionsOnIcon";
const ClosedCaptionsIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: closedCaptionsPaths });
});
ClosedCaptionsIcon.displayName = "VidstackClosedCaptionsIcon";
const CommentIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: commentPaths });
});
CommentIcon.displayName = "VidstackCommentIcon";
const ComputerIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: computerPaths });
});
ComputerIcon.displayName = "VidstackComputerIcon";
const DeviceIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: devicePaths });
});
DeviceIcon.displayName = "VidstackDeviceIcon";
const DownloadIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: downloadPaths });
});
DownloadIcon.displayName = "VidstackDownloadIcon";
const EpisodesIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: episodesPaths });
});
EpisodesIcon.displayName = "VidstackEpisodesIcon";
const EyeIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: eyePaths });
});
EyeIcon.displayName = "VidstackEyeIcon";
const FastBackwardIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: fastBackwardPaths });
});
FastBackwardIcon.displayName = "VidstackFastBackwardIcon";
const FastForwardIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: fastForwardPaths });
});
FastForwardIcon.displayName = "VidstackFastForwardIcon";
const FlagIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: flagPaths });
});
FlagIcon.displayName = "VidstackFlagIcon";
const FullscreenArrowExitIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: fullscreenArrowExitPaths });
});
FullscreenArrowExitIcon.displayName = "VidstackFullscreenArrowExitIcon";
const FullscreenArrowIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: fullscreenArrowPaths });
});
FullscreenArrowIcon.displayName = "VidstackFullscreenArrowIcon";
const FullscreenExitIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: fullscreenExitPaths });
});
FullscreenExitIcon.displayName = "VidstackFullscreenExitIcon";
const FullscreenIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: fullscreenPaths });
});
FullscreenIcon.displayName = "VidstackFullscreenIcon";
const HeartIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: heartPaths });
});
HeartIcon.displayName = "VidstackHeartIcon";
const InfoIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: infoPaths });
});
InfoIcon.displayName = "VidstackInfoIcon";
const LanguageIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: languagePaths });
});
LanguageIcon.displayName = "VidstackLanguageIcon";
const LinkIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: linkPaths });
});
LinkIcon.displayName = "VidstackLinkIcon";
const LockClosedIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: lockClosedPaths });
});
LockClosedIcon.displayName = "VidstackLockClosedIcon";
const LockOpenIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: lockOpenPaths });
});
LockOpenIcon.displayName = "VidstackLockOpenIcon";
const MenuHorizontalIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: menuHorizontalPaths });
});
MenuHorizontalIcon.displayName = "VidstackMenuHorizontalIcon";
const MenuVerticalIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: menuVerticalPaths });
});
MenuVerticalIcon.displayName = "VidstackMenuVerticalIcon";
const MicrophoneIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: microphonePaths });
});
MicrophoneIcon.displayName = "VidstackMicrophoneIcon";
const MobileIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: mobilePaths });
});
MobileIcon.displayName = "VidstackMobileIcon";
const MoonIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: moonPaths });
});
MoonIcon.displayName = "VidstackMoonIcon";
const MusicOffIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: musicOffPaths });
});
MusicOffIcon.displayName = "VidstackMusicOffIcon";
const MusicIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: musicPaths });
});
MusicIcon.displayName = "VidstackMusicIcon";
const MuteIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: mutePaths });
});
MuteIcon.displayName = "VidstackMuteIcon";
const NextIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: nextPaths });
});
NextIcon.displayName = "VidstackNextIcon";
const NoEyeIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: noEyePaths });
});
NoEyeIcon.displayName = "VidstackNoEyeIcon";
const NotificationIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: notificationPaths });
});
NotificationIcon.displayName = "VidstackNotificationIcon";
const OdometerIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: odometerPaths });
});
OdometerIcon.displayName = "VidstackOdometerIcon";
const PauseIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: pausePaths });
});
PauseIcon.displayName = "VidstackPauseIcon";
const PictureInPictureExitIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: pictureInPictureExitPaths });
});
PictureInPictureExitIcon.displayName = "VidstackPictureInPictureExitIcon";
const PictureInPictureIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: pictureInPicturePaths });
});
PictureInPictureIcon.displayName = "VidstackPictureInPictureIcon";
const PlayIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: playPaths });
});
PlayIcon.displayName = "VidstackPlayIcon";
const PlaybackSpeedCircleIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: playbackSpeedCirclePaths });
});
PlaybackSpeedCircleIcon.displayName = "VidstackPlaybackSpeedCircleIcon";
const PlaylistIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: playlistPaths });
});
PlaylistIcon.displayName = "VidstackPlaylistIcon";
const PreviousIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: previousPaths });
});
PreviousIcon.displayName = "VidstackPreviousIcon";
const QuestionMarkIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: questionMarkPaths });
});
QuestionMarkIcon.displayName = "VidstackQuestionMarkIcon";
const QueueListIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: queueListPaths });
});
QueueListIcon.displayName = "VidstackQueueListIcon";
const RadioButtonSelectedIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: radioButtonSelectedPaths });
});
RadioButtonSelectedIcon.displayName = "VidstackRadioButtonSelectedIcon";
const RadioButtonIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: radioButtonPaths });
});
RadioButtonIcon.displayName = "VidstackRadioButtonIcon";
const RepeatOnIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: repeatOnPaths });
});
RepeatOnIcon.displayName = "VidstackRepeatOnIcon";
const RepeatSquareOnIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: repeatSquareOnPaths });
});
RepeatSquareOnIcon.displayName = "VidstackRepeatSquareOnIcon";
const RepeatSquareIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: repeatSquarePaths });
});
RepeatSquareIcon.displayName = "VidstackRepeatSquareIcon";
const RepeatIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: repeatPaths });
});
RepeatIcon.displayName = "VidstackRepeatIcon";
const ReplayIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: replayPaths });
});
ReplayIcon.displayName = "VidstackReplayIcon";
const RotateIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: rotatePaths });
});
RotateIcon.displayName = "VidstackRotateIcon";
const SearchIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: searchPaths });
});
SearchIcon.displayName = "VidstackSearchIcon";
const SeekBackward10Icon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: seekBackward10Paths });
});
SeekBackward10Icon.displayName = "VidstackSeekBackward10Icon";
const SeekBackward15Icon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: seekBackward15Paths });
});
SeekBackward15Icon.displayName = "VidstackSeekBackward15Icon";
const SeekBackward30Icon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: seekBackward30Paths });
});
SeekBackward30Icon.displayName = "VidstackSeekBackward30Icon";
const SeekBackwardIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: seekBackwardPaths });
});
SeekBackwardIcon.displayName = "VidstackSeekBackwardIcon";
const SeekForward10Icon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: seekForward10Paths });
});
SeekForward10Icon.displayName = "VidstackSeekForward10Icon";
const SeekForward15Icon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: seekForward15Paths });
});
SeekForward15Icon.displayName = "VidstackSeekForward15Icon";
const SeekForward30Icon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: seekForward30Paths });
});
SeekForward30Icon.displayName = "VidstackSeekForward30Icon";
const SeekForwardIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: seekForwardPaths });
});
SeekForwardIcon.displayName = "VidstackSeekForwardIcon";
const SendIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: sendPaths });
});
SendIcon.displayName = "VidstackSendIcon";
const SettingsMenuIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: settingsMenuPaths });
});
SettingsMenuIcon.displayName = "VidstackSettingsMenuIcon";
const SettingsSwitchIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: settingsSwitchPaths });
});
SettingsSwitchIcon.displayName = "VidstackSettingsSwitchIcon";
const SettingsIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: settingsPaths });
});
SettingsIcon.displayName = "VidstackSettingsIcon";
const ShareArrowIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: shareArrowPaths });
});
ShareArrowIcon.displayName = "VidstackShareArrowIcon";
const ShareIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: sharePaths });
});
ShareIcon.displayName = "VidstackShareIcon";
const ShuffleOnIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: shuffleOnPaths });
});
ShuffleOnIcon.displayName = "VidstackShuffleOnIcon";
const ShuffleIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: shufflePaths });
});
ShuffleIcon.displayName = "VidstackShuffleIcon";
const StopIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: stopPaths });
});
StopIcon.displayName = "VidstackStopIcon";
const SubtitlesIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: subtitlesPaths });
});
SubtitlesIcon.displayName = "VidstackSubtitlesIcon";
const SunIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: sunPaths });
});
SunIcon.displayName = "VidstackSunIcon";
const TheatreModeExitIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: theatreModeExitPaths });
});
TheatreModeExitIcon.displayName = "VidstackTheatreModeExitIcon";
const TheatreModeIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: theatreModePaths });
});
TheatreModeIcon.displayName = "VidstackTheatreModeIcon";
const ThumbsDownIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: thumbsDownPaths });
});
ThumbsDownIcon.displayName = "VidstackThumbsDownIcon";
const ThumbsUpIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: thumbsUpPaths });
});
ThumbsUpIcon.displayName = "VidstackThumbsUpIcon";
const TimerIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: timerPaths });
});
TimerIcon.displayName = "VidstackTimerIcon";
const TranscriptIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: transcriptPaths });
});
TranscriptIcon.displayName = "VidstackTranscriptIcon";
const TvIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: tvPaths });
});
TvIcon.displayName = "VidstackTvIcon";
const UserIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: userPaths });
});
UserIcon.displayName = "VidstackUserIcon";
const VolumeHighIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: volumeHighPaths });
});
VolumeHighIcon.displayName = "VidstackVolumeHighIcon";
const VolumeLowIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: volumeLowPaths });
});
VolumeLowIcon.displayName = "VidstackVolumeLowIcon";
const XMarkIcon = /* @__PURE__ */ forwardRef((props, ref) => {
  return createElement(Icon, { ...props, className: cn(props.className), ref, paths: xMarkPaths });
});
XMarkIcon.displayName = "VidstackXMarkIcon";

export { AccessibilityIcon, AddIcon, AddNoteIcon, AddPlaylistIcon, AddUserIcon, AirPlayIcon, ArrowCollapseIcon, ArrowCollapseInIcon, ArrowDownIcon, ArrowExpandIcon, ArrowExpandOutIcon, ArrowLeftIcon, ArrowRightIcon, ArrowUpIcon, BookmarkIcon, CameraIcon, ChaptersIcon, ChatCollapseIcon, ChatIcon, CheckIcon, ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon, ChromecastIcon, ClipIcon, ClosedCaptionsIcon, ClosedCaptionsOnIcon, CommentIcon, ComputerIcon, DeviceIcon, DownloadIcon, EpisodesIcon, EyeIcon, FastBackwardIcon, FastForwardIcon, FlagIcon, FullscreenArrowExitIcon, FullscreenArrowIcon, FullscreenExitIcon, FullscreenIcon, HeartIcon, InfoIcon, LanguageIcon, LinkIcon, LockClosedIcon, LockOpenIcon, MenuHorizontalIcon, MenuVerticalIcon, MicrophoneIcon, MobileIcon, MoonIcon, MusicIcon, MusicOffIcon, MuteIcon, NextIcon, NoEyeIcon, NotificationIcon, OdometerIcon, PauseIcon, PictureInPictureExitIcon, PictureInPictureIcon, PlayIcon, PlaybackSpeedCircleIcon, PlaylistIcon, PreviousIcon, QuestionMarkIcon, QueueListIcon, RadioButtonIcon, RadioButtonSelectedIcon, RepeatIcon, RepeatOnIcon, RepeatSquareIcon, RepeatSquareOnIcon, ReplayIcon, RotateIcon, SearchIcon, SeekBackward10Icon, SeekBackward15Icon, SeekBackward30Icon, SeekBackwardIcon, SeekForward10Icon, SeekForward15Icon, SeekForward30Icon, SeekForwardIcon, SendIcon, SettingsIcon, SettingsMenuIcon, SettingsSwitchIcon, ShareArrowIcon, ShareIcon, ShuffleIcon, ShuffleOnIcon, StopIcon, SubtitlesIcon, SunIcon, TheatreModeExitIcon, TheatreModeIcon, ThumbsDownIcon, ThumbsUpIcon, TimerIcon, TranscriptIcon, TvIcon, UserIcon, VolumeHighIcon, VolumeLowIcon, XMarkIcon };
